import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import LogoSvg from '../atoms/logoSvg'
import useRouteParam from '../../hooks/useRouteParam'

const Wrapper = styled.footer`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  clear: both;
  a {
    color: #00b5a6;
  }
  .footer-contact {
    width: 200px;
  }
  .vulnerability-link {
    display: block;
    margin: 10px auto 30px;
    width: fit-content;
  }
  .logo-link {
    height: 64px;
    width: 170px;
    display: flex;
    align-items: center;
    margin: 0 auto 30px;
    .logo {
      margin: 0 5px 0 0;
      padding: 0;
      width: 170px;
    }
  }
  .link-area {
    display: flex;
    justify-content: center;
    align-items: center;
    a {
      margin: 0 20px;
    }
  }
  .copyright {
    padding: 20px 0;
    font-size: 14px;
    color: #555555;
  }
  ${BreakPoints.medium} {
    .link-area {
      justify-content: space-around;
      a {
        margin: 0;
      }
    }
  }
`

/**
 * フッター
 * @constructor
 */
const Footer = () => {
  const routeParam = useRouteParam('/')
  const routeParam2 = useRouteParam('/terms')
  const routeParam3 = useRouteParam('/policy')
  return (
    <Wrapper>
      <a
        href={routeParam}
        target="_blank"
        className="logo-link"
        rel="noreferrer"
      >
        <LogoSvg />
      </a>
      <div className="link-area">
        <a href={routeParam2} target="_blank" rel="noreferrer">
          利用規約
        </a>
        <a href={routeParam3} target="_blank" rel="noreferrer">
          プライバシーポリシー
        </a>
        <a href="https://clinks.jp" target="_blank" rel="noreferrer">
          運営会社
        </a>
      </div>
      <p className="copyright">
        &copy;2021 CLINKS Co., Ltd. All Rights Reserved.
      </p>
    </Wrapper>
  )
}

export default Footer
